module.exports = __webpack_public_path__ + "ee2a8498610c91b4072dc8a2f848ebe8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_staff_2.png
// module id = 187
// module chunks = 0